// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"MenItem_menu-item__CxXiJ","has-simple-language-icon":"MenItem_has-simple-language-icon__t4yZ7","menu-item-icon":"MenItem_menu-item-icon__6KfSe"};